import { render, staticRenderFns } from "./CardSubRepInfo.vue?vue&type=template&id=7116909e&scoped=true&"
import script from "./CardSubRepInfo.vue?vue&type=script&lang=js&"
export * from "./CardSubRepInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardSubRepInfo.vue?vue&type=style&index=0&id=7116909e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7116909e",
  null
  
)

export default component.exports